import { isDesktop, getValueByDevice } from './utils';

const LANGUAGE = process.env.SP_LANGUAGE;
const ENVIRONMENT = process.env.SP_ENVIRONMENT;
const JURISDICTION = process.env.SP_JURISDICTION;

const DEFAULTS = {
  environment: ENVIRONMENT,
  jurisdiction: JURISDICTION,
};

const regSource = getValueByDevice({ desktop: 'AP', tablet: 'MZ', mobile: 'MZ' });
const obRegSource = getValueByDevice({ desktop: 'AP', tablet: 'MO', mobile: 'MO' });

export const config = {
  domain: process.env.SP_DOMAIN,
  redirect_fallback: process.env.SP_SB_REDIRECT,
  featureFlags: {
    accurateOBRedirect: process.env.ACCURATE_OB_REDIRECT === 'true',
  },
  graphqlClient: {
    url: process.env.SP_GRAPHQL_CLIENT_URL,
  },
  registrationFlow: {
    ...DEFAULTS,
    locale: LANGUAGE,
    regSource,
  },
  webLoginPreferences: {
    casUrl: process.env.SP_CAS_URL,
    serviceUrl: `${process.env.SP_SESSION_LISTENER_URL}/logout`,
    custLogin: false,
    enableFlagHandling: true,
    enableRecaptcha: JURISDICTION === 'com',
  },
  casSessionManager: {
    casUrl: process.env.SP_CAS_URL,
    custLogin: false,
    sessionLogoutListener: {
      url: process.env.SP_SESSION_LISTENER_URL,
      heartbeatTimeout: 3600000,
      retryTime: 30000,
    },
    sessionMarkActive: {
      iamAliveDebounceTime: 5000,
      iamAliveDebounceMaxWaitTime: 5000,
      retryMaxTime: 5000,
      retryInterval: 1000,
    },
    enableFlagHandling: true,
    enableRecaptcha: JURISDICTION === 'com',
  },
  loginFlow: {
    ...DEFAULTS,
    locale: LANGUAGE,
  },
  accountActions: {
    language: LANGUAGE,
    env: ENVIRONMENT,
    jurisdiction: JURISDICTION,
    isMobile: !isDesktop,
    // the only place where regSource is used in AA is generating OB deposit URL
    regSource: obRegSource,
  },
  obSessionService: {
    obSessionServiceUrl: process.env.SP_OB_SESSION_URL,
    casUrl: process.env.SP_CAS_URL,
  },
  sessionService: {
    sessionServiceUrl: process.env.SESSION_SERVICE_URL,
  },
  accountFlagsFeature: {
    jurisdiction: JURISDICTION,
    isMobileDevice: !isDesktop,
  },
  accountFlagsFlowFeature: {
    ...DEFAULTS,
    locale: LANGUAGE,
  },
  recaptchaService: {
    siteKey: process.env.RECAPTCHA_SITE_KEY,
  },
};
